import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';

import '@zippytech/react-toolkit/Accordion/index.css';

import PublishPlaybook from "./PublishPlaybook";
import Communities from './Communities'
import Organizations from './Organization'
import ConfigureActivities from './ConfigureActivities'
import ActiveInitiative from './ActiveInitiative'
import ActiveInitiativeProgress from './ActiveInitiativeProgress';
import CompletedInitiative from './CompletedInitiative'
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class IndexResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            transactionTime: 10,
            transitioinFunction: 'linear'
        }
    }

    render() {
        const { collapsedResourcePaneIndex } = this.props
        return (
            this.props.resourcePaneFlag === "PublishPlaybook" ?
                <PublishPlaybook {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> :
                this.props.resourcePaneFlag === "Organizations" ?
                    <Organizations {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> :
                    this.props.resourcePaneFlag === "Communities" ?
                        <Communities {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> :
                        this.props.resourcePaneFlag === "ConfigureActivities" ?
                            <ConfigureActivities {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> :
                            this.props.resourcePaneFlag === "ActiveInitiative" ?
                                <ActiveInitiative {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> :
                                this.props.resourcePaneFlag === "ActiveProgress" ?
                                    <ActiveInitiativeProgress {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> :
                                    this.props.resourcePaneFlag === "CompletedInitiatives" ?
                                        <CompletedInitiative {...this.props} collapsedResourcePaneIndex={collapsedResourcePaneIndex} /> : ""
        )
    }
}


export default IndexResourcePane;

